@let user = user$ | async;
<div
  class="wrapper"
  [ngStyle]="styles()"
  [attr.data-userid]="dataUserId()"
  *pluginsUserProfileLink="
    user?.id;
    enabled: profileLinkEnabled() && user?.type === 'user'
  "
>
  @let memberCount = count();
  <div
    class="user-avatar"
    role="img"
    [title]="
      titleTranslationKey()
        | translate
          : {
              name: name(),
              count: memberCount
                ? (memberCount | abbreviateNum | async)
                : undefined,
            }
    "
  >
    @switch (status()) {
      @case ('pending') {
        <div class="user-avatar__pending"></div>
      }
      @case ('success') {
        @let avatarValue = avatar();
        @if (avatarValue) {
          <img
            class="user-avatar__avatar"
            [src]="avatarValue"
            [alt]="'userDetails.avatarAlt' | translate: { name: name() }"
            referrerpolicy="no-referrer"
          />
        } @else if (user?.type !== 'group') {
          <plugins-user-text
            class="user-avatar__label"
            [text]="user?.type !== 'missing' ? initials() : placeholderText"
          />
        } @else {
          <icon-user
            [multiple]="true"
            class="user-avatar__group"
            [ngClass]="{ 'user-avatar__group--size': !!groupIconSize() }"
            [size]="groupIconSize() ? 'md' : undefined"
            [ngStyle]="{ '--md': groupIconSize() }"
          />
        }
      }
      @case ('error') {
        <plugins-user-text
          class="user-avatar__label"
          [text]="placeholderText"
        />
      }
    }
  </div>
</div>
